import { icAsset } from "../image/image-src";
import SquarePayArea from "./SquarePayArea";
export const SquarePayPopup = ({
  onOk,
  onClose,
}: {
  onOk?: (x: { token: string }) => void;
  onClose: () => void;
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-fit rounded-[1rem] border border-[#D7DCE3] bg-white p-8 text-center shadow-lg">
        <div className="flex flex-col items-center gap-6">
          <div className="flex w-full flex-col gap-2">
            <div className="w-[343px]">
              <span
                className="close absolute right-[0.875rem] top-[0.875rem]"
                onClick={onClose}
              >
                <img
                  className="close-icon"
                  src={icAsset("../assets/images/icons/close.svg")}
                  alt="close"
                />
              </span>
              <div className="pb-5"></div>
              <SquarePayArea onOk={onOk} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
